import React from 'react';
export default class ElegantResumeSkills extends React.Component{

    getResumeBlock(data, index){

        return <div data-v-5a80631c="" className="section-skill" key={index}>
                        { data.names && <b data-v-5a80631c="">{data.names}</b> }
                        { data.proficiency && <span data-v-5a80631c="">{data.proficiency}</span> }
                    </div>
    }

    render(){
        return  <div data-v-5a80631c="" className="section">
                    <div data-v-5a80631c="" className="section-headline">{this.props.title}</div>
					<div data-v-5a80631c="" className="section-item">
                    	{this.props.data.map((item, index) => {
                        	return this.getResumeBlock(item, index);
						})}
					</div>
                </div>

    }
}